import React from 'react';
import type {BoxProps} from '@tempo/core';
import {Center, CircularProgress} from '@tempo/core';

type PageLoaderProps = BoxProps;

const PageLoader = ({...rest}: PageLoaderProps): React.ReactElement => {
	return (
		<Center
			pt={{base: 'd4c.navbar.height.base', sm: 'd4c.navbar.height.sm'}}
			{...rest}
		>
			<CircularProgress size={20} thickness="6px" isIndeterminate={true} />
		</Center>
	);
};

export default PageLoader;
